import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AppErrors, NotFoundError } from '@fitness-force/models';;
import { environment } from '@fitness-force/environments';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';
@Injectable({
  providedIn: 'root',
})
export class PaymentGatewayService {
  private http = inject(HttpClient);


  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  getSettlementByTenantId(tenantId: number, allparams: any): Observable<any> {
    let parsedParams = new HttpParams();
    allparams.forEach((p: any) => {
      parsedParams = parsedParams.append(p.name, p.value);
    });
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.PAYMENT.GET_SETTLEMENTS
      .replace('{tenant_id}', tenantId.toString());
    return this.http
      .get(url, {
        headers: this.httpOptions.headers,
        params: parsedParams,
      })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  exportSettlementByTenantId(tenantId: number,payload: any): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.PAYMENT.EXPORT_SETTLEMENTS
      .replace('{tenant_id}', tenantId.toString());
    return this.http
      .post(url, payload,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  downloadSettlementById(tenantId: number,id:number,payload: any): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.PAYMENT.DOWNLOAD_SETTLEMENT_BY_ID
      .replace('{tenant_id}', tenantId.toString())
      .replace('{settlement_id}', id.toString());
    return this.http
      .post(url, payload,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

}
